import { useDragWithoutPreview } from "util/react-utils";
import { observer } from "mobx-react";

import { DND_TRANSITION_HANDLE } from "pages/editor/lib/timeline";
import { undoManager } from "pages/editor/state/store/undomanager";

import { Handle } from "./transition.styles";

/**
 * @typedef {Object} TransitionHandleProps
 * @property {String} id Associated transition ID
 * @property {String} side DND_TRANSITION_HANDLE_LEFT | DND_TRANSITION_HANDLE_RIGHT
 * @property {Boolean} active Whether the transition is selected or not
 */

/**
 * @summary - Transiton handle component
 * @param {TransitionHandleProps}
 * @returns {React.Element}
 */
const TransitionHandle = ({ side, transition, active }) => {
    const [, drag] = useDragWithoutPreview({
        type: DND_TRANSITION_HANDLE,
        end: () => undoManager.stopGroup(),
        item: {
            type: DND_TRANSITION_HANDLE,
            transition,
            side
        }
    });
    return (
        <Handle
            data-testid={`transition-handle-${transition.id}-${side}`}
            {...{ side, active, ref: drag }}
        />
    );
};

export default observer(TransitionHandle);
